const UnitUploadThesis = {
  tableConfig: {
    showCheckbox: true,
    minWidth: 1440,
    checkboxFilter: '{dealingFlag}==1', // 成立 显示 checkbox
    comment: '为了避免误操作，论文分配至专家后短信、邮件提醒会在5分钟后发送。论文分配至二级单位后短信提醒会在10分钟后发送。'
  },
  queryList: [
    {
      name: 'unitName',
      label: '学校名称',
      component: 'input'
    },
    {
      name: 'academyName',
      label: '院系名称',
      component: 'input'
    },
    {
      name: 'firstSubjectName',
      label: '一级学科',
      component: 'select',
      request: {
        method: 'post',
        addr: '/conf/confFirstSubject/all',
        data: {},
        format: {
          value: 'name',
          label: 'name'
        }
      }
    },
    {
      name: 'sendBatch',
      label: '批次号',
      component: 'input'
    },
    {
      name: 'receiveType',
      label: '接收类型',
      component: 'select',
      componentAttr: {
        options: [{
          value: '1',
          label: '专家'
        }, {
          value: '2',
          label: '接收单位'
        }]
      }
    },
    {
      name: 'acceptStatus',
      label: '接收状态',
      component: 'select',
      componentAttr: {
        options: [{
          value: '0',
          label: '未指派'
        }, {
          value: '1',
          label: '未送审'
        }, {
          value: '2',
          label: '待接收'
        }, {
          value: '3',
          label: '已接收'
        }, {
          value: '4',
          label: '拒绝接收'
        }, {
          value: '5',
          label: '已评阅'
        }]
      }
    }
  ],
  urlMap: {
    'select': {
      url: '/school/schoolDegreeOffice/getReceiveUnitPaperInfo'
    }
  },
  operList: [// 操作列表
    {
      name: 'batchMatch',
      label: '批量分配至专家',
      show: true,
      action: {
        type: 'func',
        addr: 'recordSelectedAndJump',
        data: {
          name: 'batchSendThesisIds',
          addr: 'thesisManage/batchMatchExpert?from=unit'
        }
      }
    },
    {
      name: 'batchMatchUnit',
      label: '批量分配至学院',
      show: true,
      action: {
        type: 'func',
        addr: 'recordSelectedAndJump',
        data: {
          name: 'batchSendThesisIds',
          addr: 'thesisManage/batchMatchUnit?from=unit'
        }
      }
    },
    {
      name: 'generateLinks',
      label: '导出未分配评阅链接',
      show: true,
      action: {
        type: 'request',
        addr: '/exp/expReviewInfo/exportPaperInfo',
        data: '{searchParam}',
        nextAction: 'download'
      }
    },
    {
      name: 'resetLinks',
      label: '重置已退回评阅链接',
      show: true,
      action: {
        type: 'request',
        addr: '/exp/expReviewInfo/exportResetPaperInfo',
        data: '{searchParam}',
        refresh: true,
        nextAction: 'download'
      }
    },
    {
      name: 'download',
      label: '下载文件',
      show: false,
      action: {
        type: 'url',
        addr: '{data}'
      }
    }
  ],
  titles: [
    {
      name: 'expReviewId',
      key: true
    },
    {
      name: 'unitName',
      label: '学校名称'
    },
    {
      name: 'academyName',
      label: '所在学院'
    },
    {
      name: 'firstSubjectName',
      width: 95,
      label: '一级学科'
    },
    {
      name: 'secondSubjectName',
      width: 95,
      label: '二级学科'
    },
    {
      name: 'titleCn',
      label: '论文题目'
    },
    {
      name: 'receiveType',
      label: '接收类型'
    },
    {
      name: 'receiveName',
      label: '接收人'
    },
    {
      name: 'acceptStatus',
      width: 100,
      label: '接收状态'
    },
    {
      name: 'reviewEndTime',
      label: '评阅截止时间'
    },
    {
      name: 'batchName',
      label: '批次号'
    },
    {
      name: 'operation',
      label: '操作',
      width: 180,
      actionList: [
        {
          label: '详情',
          name: 'detail',
          kind: 'primary', // error
          type: 'subRouter', // request, router, dialog, func
          addr: 'thesisManage/matchExpert?id={id}&readonly&from=unit'
        }
        // ,
        // {
        //   label: '分配至专家',
        //   name: 'match',
        //   kind: 'primary', // error
        //   type: 'subRouter', // request, router, dialog, func
        //   addr: 'thesisManage/matchExpert?id={expReviewId}&from=unit'
        // },
        // {
        //   label: '分配至学院',
        //   name: 'matchUnit',
        //   kind: 'primary', // error
        //   type: 'subRouter', // request, router, dialog, func
        //   addr: 'thesisManage/matchUnit?id={expReviewId}&from=unit'
        // }
      ]
    }
  ]
}
export default UnitUploadThesis



// WEBPACK FOOTER //
// ./src/layout/regularPage/config/thesisManage/unitUploadThesis.js